import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import { Link } from '@/components/links';
import IconMail from '@/assets/icons/heroIcons/Mail.svg';
import IconPhone from '@/assets/icons/heroIcons/Phone.svg';
import IconQuestionMarkCircle from '@/assets/icons/heroIcons/QuestionMarkCircle.svg';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import MoreInfoSection from '@/sections/MoreInfo';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { Trans, useTranslation } from 'react-i18next';
import { EXTERNAL_LINKS, LINKS } from '@/constants/links';
import React from 'react';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import Image from 'next/image';
import { formatPhoneNumber } from '@/utils/formatting';
import { CONTACT_EMAIL, CONTACT_PHONE } from '@/constants/contacts';
import HeroSimple from '@/sections/HeroSimple';
import { SeoHeader } from '@/components/SeoHeader';
import { Text, Headline } from '@/components/typography';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import IconShoppingCart from '@/assets/icons/heroIcons/Shopping-cart.svg';
import IconMobile from '@/assets/icons/heroIcons/Device-mobile.svg';
import IconUser from '@/assets/icons/heroIcons/User-group.svg';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import ChatboxSection from '@/sections/contacts/ChatboxSection';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(82);
  const {
    menuPromoBanners
  } = t0;
  usePageView("contact");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["contact", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const isCsLanguage = useIsSelectedLanguage("cs");
  const isSkLanguage = useIsSelectedLanguage("sk");
  const isHuLanguage = useIsSelectedLanguage("hu");
  let t2;
  if ($[1] !== t) {
    t2 = function renderAddress() {
      return <Text variant="p2" as="div" className="text-gray-800"><p className="mb-2 font-semibold">{t("company")}</p><p>{t("address.street")}</p><p>{t("address.city")}</p></Text>;
    };
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const renderAddress = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("seo.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("seo.description");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <SeoHeader title={t3} description={t4} />;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="bgCircle absolute top-0 left-0 h-[30rem] w-[30rem] -translate-x-1/2 -translate-y-1/2 rotate-180 lg:h-[50rem] lg:w-[50rem] lg:-translate-x-1/3 lg:-translate-y-1/3" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("banner.title");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("banner.text");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <Text variant="p1" className="text-center text-gray-800">{t8}</Text>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t9) {
    t10 = <HeroSimple title={t7} titleClassName="pb-4">{t9}</HeroSimple>;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== isCsLanguage || $[21] !== isHuLanguage || $[22] !== isSkLanguage || $[23] !== t) {
    t11 = isCsLanguage || isSkLanguage ? <ChatboxSection /> : <div className="rounded-2xl bg-white p-4 lg:p-8"><div className="flex flex-col gap-8 md:flex-row"><div className="flex w-full flex-shrink-1 flex-col items-center gap-2"><IconQuestionMarkCircle className="h-10 w-10 text-blue-500" /><p className="mb-2 text-base font-semibold md:text-xl">{t("contacts.items.1.title")}</p><p className="text-sm md:text-base"><Trans t={t} i18nKey="contacts.items.1.text"><Link testId="contactFaq" analyticsParam="contactFaq" to={LINKS().faq} /></Trans></p></div><div className="flex w-full flex-shrink-1 flex-col items-center gap-2"><IconMail className="h-10 w-10 text-blue-500" /><p className="mb-2 text-base font-semibold md:text-xl">{t("contacts.items.2.title")}</p><p className="text-sm md:text-base"><Link to={`mailto:${CONTACT_EMAIL}`} analyticsParam="contactEmail" testId="contactEmail">{CONTACT_EMAIL}</Link></p><p className="text-light-gray-500 text-sm">{t("contacts.items.2.text")}</p></div>{!isHuLanguage && CONTACT_PHONE && <div className="flex w-full flex-shrink-1 flex-col items-center gap-2"><IconPhone className="h-10 w-10 text-blue-500" /><p className="mb-2 text-base font-semibold md:text-xl">{t("contacts.items.3.title")}</p><p className="text-sm md:text-base"><Link to={`tel:${formatPhoneNumber(CONTACT_PHONE)}`} analyticsParam="contactPhone" testId="contactPhone">{formatPhoneNumber(CONTACT_PHONE, {
                spacedTriples: true
              })}</Link></p><p className="text-light-gray-500 text-sm">{t("contacts.items.3.text")}</p></div>}</div></div>;
    $[20] = isCsLanguage;
    $[21] = isHuLanguage;
    $[22] = isSkLanguage;
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t) {
    t12 = t("subtitle.1");
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12) {
    t13 = <Headline as="h2" variant="h4" className="mb-8">{t12}</Headline>;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== renderAddress) {
    t14 = renderAddress();
    $[29] = renderAddress;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = <div>{t13}{t14}</div>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = EXTERNAL_LINKS();
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  const t17 = t16.map;
  let t18;
  if ($[35] !== t) {
    t18 = t("map");
    $[35] = t;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t18) {
    t19 = <div><Link to={t17} analyticsParam="contactMap" testId="contactMap" target="_blank"><Image src="/images/sections/contact/cs/map.png" width={536} height={240} alt={t18} /></Link></div>;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t15 || $[40] !== t19) {
    t20 = <div className="rounded-2xl bg-white p-4 pt-8 lg:p-8"><div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">{t15}{t19}</div></div>;
    $[39] = t15;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t) {
    t21 = t("subtitle.2");
    $[42] = t;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t21) {
    t22 = <Headline as="h2" variant="h4" className="mb-8">{t21}</Headline>;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== renderAddress) {
    t23 = renderAddress();
    $[46] = renderAddress;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <b className="font-semibold" />;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t) {
    t25 = <p><Trans t={t} i18nKey="dataBox">{t24}</Trans></p>;
    $[49] = t;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <b className="font-semibold" />;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== t) {
    t27 = <p><Trans t={t} i18nKey="CIN">{t26}</Trans></p>;
    $[52] = t;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] !== t25 || $[55] !== t27) {
    t28 = <Text variant="p2" as="div" className="text-gray-800">{t25}{t27}</Text>;
    $[54] = t25;
    $[55] = t27;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== t23 || $[58] !== t28) {
    t29 = <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-start md:gap-20">{t23}{t28}</div>;
    $[57] = t23;
    $[58] = t28;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  let t30;
  if ($[60] !== t22 || $[61] !== t29) {
    t30 = <div className="rounded-2xl bg-white px-4 py-6 lg:p-8">{t22}{t29}</div>;
    $[60] = t22;
    $[61] = t29;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  let t31;
  if ($[63] !== t11 || $[64] !== t20 || $[65] !== t30) {
    t31 = <div className="relative z-10 mx-auto mt-4 flex max-w-[75rem] flex-col gap-6 px-4 lg:mt-5">{t11}{t20}{t30}</div>;
    $[63] = t11;
    $[64] = t20;
    $[65] = t30;
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  let t32;
  if ($[67] !== t10 || $[68] !== t31) {
    t32 = <div className="z-10 bg-blue-50 pb-10 lg:pb-20">{t10}{t31}</div>;
    $[67] = t10;
    $[68] = t31;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  let t33;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <SectionDelimiter color="bg-blue-100" background="bg-blue-50" />;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  let t34;
  if ($[71] !== isCsLanguage || $[72] !== t) {
    t34 = <div className="relative z-10"><MoreInfoSection buttons={isCsLanguage ? [{
        analyticsParam: "contactMoreInfoDeferredPayment",
        icon: <IconDeferredPayment className="fillButtonIcon" />,
        testId: "contactMoreInfoDeferredPayment",
        title: t("core:products.deferredPayment"),
        to: LINKS().deferredPayment
      }, {
        analyticsParam: "contactMoreInfoRevolvingApplication",
        icon: <IconMaxi className="fillButtonIcon" />,
        testId: "contactMoreInfoRevolvingApplication",
        title: t("core:products.revolving"),
        to: LINKS().revolving
      }, {
        analyticsParam: "contactMoreInfoPayInThree",
        icon: <IconThird className="fillButtonIcon" />,
        testId: "contactMoreInfoPayInThree",
        title: t("core:link.payInThree"),
        to: LINKS().payInThree
      }, {
        analyticsParam: "contactMoreInfoCard",
        icon: <IconCard className="fillButtonIcon" />,
        testId: "contactMoreInfoCard",
        title: t("core:products.card"),
        to: LINKS().card
      }] : [{
        analyticsParam: "contactMoreInfoPayInThree",
        icon: <IconThird className="fillButtonIcon" />,
        testId: "contactMoreInfoPayInThree",
        title: t("core:products.payInThree"),
        to: LINKS().payInThree
      }, {
        analyticsParam: "contactMoreInfoWhereToShop",
        icon: <IconShoppingCart className="fillButtonIcon" />,
        testId: "contactMoreInfoWhereToShop",
        title: t("core:products.whereToShop"),
        to: LINKS().whereToShop
      }, {
        analyticsParam: "homepageMobileApp",
        icon: <IconMobile className="fillButtonIcon" />,
        testId: "contactMoreInfoMobileApp",
        title: t("core:products.mobileApp"),
        to: LINKS().mobileApp
      }, {
        analyticsParam: "contactMoreInfoAboutCompany",
        icon: <IconUser className="fillButtonIcon" />,
        testId: "contactMoreInfoAboutCompany",
        title: t("core:link.aboutUs"),
        to: LINKS().aboutCompany
      }]} /></div>;
    $[71] = isCsLanguage;
    $[72] = t;
    $[73] = t34;
  } else {
    t34 = $[73];
  }
  let t35;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    $[74] = t35;
  } else {
    t35 = $[74];
  }
  let t36;
  if ($[75] !== t34) {
    t36 = <div className="relative overflow-hidden bg-blue-100">{t34}{t35}</div>;
    $[75] = t34;
    $[76] = t36;
  } else {
    t36 = $[76];
  }
  let t37;
  if ($[77] !== menuPromoBanners || $[78] !== t32 || $[79] !== t36 || $[80] !== t5) {
    t37 = <Layout menuPromoBanners={menuPromoBanners}>{t5}{t6}{t32}{t33}{t36}</Layout>;
    $[77] = menuPromoBanners;
    $[78] = t32;
    $[79] = t36;
    $[80] = t5;
    $[81] = t37;
  } else {
    t37 = $[81];
  }
  return t37;
}
export const getStaticProps: GetStaticProps = async ctx => ({
  props: {
    menuPromoBanners: await getAllPageMenuPromoBanners(),
    ...(await getIntlProps(ctx, ['core', 'contact']))
  }
});